module.exports = __webpack_public_path__ + "18bdb448d3d4dd29729845f9dc915f74.svg";